import {
  Avatar, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton,
  Input, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper, Select, Snackbar, Tooltip, Typography, createMuiTheme,
  CardContent, InputAdornment, CardHeader, FormControlLabel, Checkbox, Backdrop
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { green, red } from '@material-ui/core/colors';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import RefreshIcon from '@material-ui/icons/Refresh';
import RoomIcon from '@material-ui/icons/Room';
import SearchIcon from '@material-ui/icons/Search';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbUpDownIcon from '@material-ui/icons/ThumbDown';
import WorkIcon from '@material-ui/icons/Work';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { openBlob, sc, getUser } from 'src/utils/Common';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { setTask } from '../../store/actions/taskActions';
import FgsArama from './FgsCall';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import InfoIcon from '@material-ui/icons/Info';
import axiosHeadOffice from 'src/utils/axiosHeadOffice';
import CloseIcon from '@material-ui/icons/Close';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import SaveIcon from '@material-ui/icons/Save';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteIcon from '@material-ui/icons/Delete';
import TriageMaterialOrder from 'src/views/MaterialOrder/Create/TriageMaterialOrder'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { getTasksRequest } from '../../store/actions';
import {
  loadBaslandiJob, saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import { getDefectRequest, getLabourRequest, getMaterialRequest } from '../../store/actions';
import { addDefects, resetDefects } from '../../store/actions/defectActions';
import { addLabours, resetLabours } from '../../store/actions/labourActions';
import { addMaterials, resetMaterials } from '../../store/actions/materialActions';
import DefectTriage from '../WorkOrder/DefectTriage';
import { filterActions } from 'src/store/slices/filterSlice';
import { useRef } from "react";
import _ from "lodash";

let MesafeSonuc = 0;

const useStyles = makeStyles((theme) => ({
  root: {},
  avatarAtanan: {
    backgroundColor: red[500],
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  avatar1Atanan: {
    backgroundColor: green[500],
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px',
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonAtanan: {
    padding: 2,
  },
  dividerAtanan: {
    backgroundColor: '#1D3343'
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  urgentButton: {
    marginLeft: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    color: '#b2102f'
  },
  buttonAtanan: {
    borderColor: 'green',
    color: 'green',
    '&:hover': {
      borderColor: 'darkgreen',
      color: 'darkgreen',
    },
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Notifications({
  className, AtananIsler, handleRefresh, loading, setTask, materialReducer, defectReducer, labourReducer, resetDefects, resetLabours, resetMaterials, addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest,
}) {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const dispatch = useDispatch();
  const filter = useSelector((state) => state.filter?.searched);
  const [stateDurum, setStateDurum] = useState('');
  const [stateWarranty, setStateWarranty] = useState('');
  const [ReceiptNo, setReceiptNo] = useState('');
  const [open, setOpen] = React.useState(false);
  const [rejectOpen, setRejectOpen] = React.useState(false);
  const [rejectJob, setRejectJob] = React.useState();
  const [confirmJob, setconfirmJob] = React.useState();
  const [confirmnewStatus, setconfirmnewStatus] = React.useState();
  const [Enlem, setEnlem] = useState('');
  const [Boylam, setBoylam] = useState('');
  // const [MesafeSonuc, setMesafeSonuc] = useState("");
  const locale = localStorage.getItem('i18nextLng');
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: t('success_message') });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [confirmRejectTitle, setConfirmRejectTitle] = useState('');
  const [confirmRejectDescription, setConfirmRejectDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [loadingIOT, setLoadingIOT] = useState(false);
  const today = new Date();
  const [StartDate, setStartDate] = useState(sessionStorage.getItem('StartDate') ? sessionStorage.getItem('StartDate') : new Date(today));
  const [EndDate, setEndDate] = useState(sessionStorage.getItem('EndDate') ? sessionStorage.getItem('EndDate') : new Date(today));
  // const [EndDate, setEndDate] = useState(new Date(today));
  const [sortedData, setSortedData] = useState([]);
  const [openChooseDate, setopenChooseDate] = useState(false);
  const history = useHistory();
  const [IsAI, setIsAI] = useState(false)
  const [StatusData, setStatusData] = useState([]);
  const [defectsAndMaterials, setDefectsAndMaterials] = useState([]);
  const [defectAndMaterialList, setDefectAndMaterialList] = useState([]);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [predictions, setPredictions] = useState([]);
  const [OpenTriageMaterialOrder, setOpenTriageMaterialOrder] = useState(false);
  const [OpenAIDialog, setOpenAIDialog] = useState(false);
  const [selectedDefect, setSelectedDefect] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [OrderNr, setOrderNr] = useState('');
  const [MaterialOrderId, setMaterialOrderId] = useState(0);
  const [workOrder, setWorkOrder] = useState([]);
  const [readonly, setReadonly] = useState(true);
  const [open1, setOpen1] = useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const [sessionWorkOrderId, setSessionWorkOrderId] = useState();

  //GFSM-6565 -> Job Control de send to center dan sonra iş emirleri doğru listelenmiyordu. Bu sorun giderildi.
  const initialAtananIsler = useRef(AtananIsler); 
  const refreshed = useRef(false); 

  useEffect(() => {
    if (!refreshed.current && !_.isEqual(initialAtananIsler.current, AtananIsler)) {
      handleRefresh();
      refreshed.current = true; 
    }
  }, [AtananIsler, handleRefresh]);
  
  useEffect(() => {
    handleRefresh();
  }, []);

  useEffect(() => {
    if (AtananIsler && AtananIsler.length > 0) {
      let curr = AtananIsler[0];
      if (parseInt(AtananIsler[0].StatusCode) === 33) {
        setReadonly(false);
        saveBaslandiJob(AtananIsler[0]);
        curr = AtananIsler[0];
        if (parseInt(AtananIsler[0].ReceiptNo) === parseInt(workOrder.ReceiptNo)) {
          curr = AtananIsler[0];
        } else {
          removeBaslandiJob();
          saveBaslandiJob(AtananIsler[0]);
          curr = loadBaslandiJob()[0];
        }
      }
      const kulModelKodu = curr.ModelCode;
      const garantiTipi = curr.WarrantyTypeId || 0;
      const uyil = curr.ProductionYear || 0;
      const udonem = curr.ProductionMonth || 0;
      const WorkOrderIdParam = curr.ReceiptNo || 0;

      if (kulModelKodu !== undefined && kulModelKodu !== null && kulModelKodu.length > 0) {
        resetDefects();
        resetMaterials();
        resetLabours();
        getDefectRequest(kulModelKodu, garantiTipi);
        getMaterialRequest(kulModelKodu, garantiTipi, 1, uyil, udonem, WorkOrderIdParam);
        getLabourRequest(kulModelKodu, garantiTipi, 1, WorkOrderIdParam);
        if (curr.WorkOrderDetails) {
          const selectedDefects = [];
          let labours = {};
          let materials = {};
          curr.WorkOrderDetails.forEach((h, index) => {
            selectedDefects.push(h.DefectId);
            labours = { ...labours, [h.DefectId]: [] };
            materials = { ...materials, [h.DefectId]: [] };
          });
          addDefects(selectedDefects);
          if (curr.WorkOrderLabours) {
            curr.WorkOrderLabours.forEach((i, index) => {
              labours[i.DefectId].push(i.LabourCode.toString());
            });
            addLabours(labours);
          }
          if (curr.WorkOrderMaterials) {
            curr.WorkOrderMaterials.forEach((i, index) => {
              materials[i.DefectId].push(i.MaterialCode.toString());
              materials = { ...materials, [i.MaterialCode]: i.Count };
            });
            addMaterials(materials);
          }
        }
      }
    }
    setLoading2(false);
    // eslint-disable-next-line
  }, [workOrder]);

  useEffect(() => {
    localStorageKaydet();
  }, [defectReducer, materialReducer, labourReducer]);


  const localStorageKaydet = () => {
    if (defectReducer.Data.length === 0) {
      return;
    }
    let job = AtananIsler[0];
    const hizmetlerH = [];
    const isciliklerH = [];
    const malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        DefectId: hizmet,
        DefectCode: hizmetRedux?.UserCode,
        DefectDesc: hizmetRedux?.DefectDesc,
        // TIP: hizmetRedux?.DefectType,
        // TIP_KODU: hizmetRedux?.DefectTypeCode,
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter((d) => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerH.push({
              LabourId: iscilik.LabourId,
              DefectId: hizmet,
              LabourCode: iscilik.LabourCode,
              LabourDesc: iscilik.LabourDesc,
              Price: iscilik.Price,
              PriceWithWat: iscilik.PriceWithWat,
              VatRate: iscilik.VatRate,
              VatId: iscilik.VatId,
              LabourPriceListId: parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceListIdWithoutWarranty : iscilik.PriceListId,
              LabourPriceId: iscilik.PriceId
            });
            iscilik_toplam += parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceWithoutWarranty : iscilik.Price;
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter((d) => d.MaterialCode === materialArray[m])[0];
          if (malzeme) {
            malzemelerH.push({
              MaterialId: malzeme.MaterialId,
              DefectId: hizmet,
              DefectDesc: hizmetRedux?.CategoryLevel1 + "/" + hizmetRedux?.CategoryLevel2 + "/" + hizmetRedux?.UserCode + "/" + hizmetRedux?.DefectDesc,
              MaterialCode: malzeme.MaterialCode,
              Count: materialReducer[malzeme.MaterialCode],
              MaterialDesc: malzeme.MaterialDesc,
              Price: malzeme.Price,
              PriceWithWat: malzeme.PriceWithWat,
              VatRate: malzeme.VatRate,
              VatId: malzeme.VatId,
              MaterialPriceListId: malzeme.PriceListId,
              MaterialPriceId: malzeme.PriceId
            });
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      WorkOrderDetails: hizmetlerH,
      WorkOrderLabours: isciliklerH,
      WorkOrderMaterials: malzemelerH,
      EMploymentCostTotal: iscilik_toplam,
      MaterialTotal: malzeme_toplam,
    };
    saveBaslandiJob(job);
    AtananIsler = loadBaslandiJob();
  };

  // work end
  let SonucNotuDeger = '';
  let ProjeKoduDeger = '';
  if (AtananIsler === undefined || AtananIsler[0] === undefined) {
    SonucNotuDeger = '';
    ProjeKoduDeger = '';
  } else {
    SonucNotuDeger = AtananIsler[0].Notes || '';
    ProjeKoduDeger = AtananIsler[0].ProjectCode || '';
  }
  const [SonucNotu, setSonucNotu] = useState(SonucNotuDeger);
  const [ProjeKodu, setProjeKodu] = useState(ProjeKoduDeger);

  let currMaterialSum = 0;
  let currLabourSum = 0;
  let currTransportSum = 0;
  let currExtraSum = 0;

  let currMaterialVatSum = 0;
  let currLabourVatSum = 0;
  let currTransportVatSum = 0;
  let currExtraVatSum = 0;

  if (AtananIsler !== undefined && AtananIsler[0] !== undefined) {
    AtananIsler[0].WorkOrderMaterials.forEach((mrow, index) => {
      currMaterialSum += mrow.PriceWithWat * mrow.Count;
      currMaterialVatSum += mrow.Price * mrow.Count;
    });
    AtananIsler[0].WorkOrderLabours.forEach((mrow, index) => {
      currLabourSum += mrow.PriceWithWat;
      currLabourVatSum += mrow.Price;
    });
    AtananIsler[0].WorkOrderTransport.forEach((mrow, index) => {
      currTransportSum += mrow.MaterialPriceWithWat;
      currTransportVatSum += mrow.MaterialPrice;
    });
    AtananIsler[0].WorkOrderExtra.forEach((mrow, index) => {
      currExtraSum += mrow.MaterialPriceWithWat;
      currExtraVatSum += mrow.MaterialPrice;
    });
  }

  const GetStatusData = (mobileStatusId, receiptNo) => {
    var UserTypeId = SessionUser.TechnicianId;
    axios.get('/GetWorkOrderStatusLogic/' + mobileStatusId + '/' + UserTypeId + '/' + receiptNo).then((response) => {
      const Deger = response.data;
      setStatusData(Deger);
      setIsAI(Deger.find(i => i.MobileStatusId == mobileStatusId)?.IsAI);
      setLoading2(false);
    }).catch((error) => {
      setStatusData([]);
      setLoading2(false);
    });
  }

  const StartDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', Deger);
  };

  const EndDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', Deger);
  };

  // const EndDatehandleChange = (value) => {
  //   const Deger = moment(value).format('YYYY-MM-DD');
  //   setEndDate(Deger);
  //   sessionStorage.removeItem('StartDate');
  //   sessionStorage.setItem('StartDate', Deger);

  //   sessionStorage.removeItem('EndDate');
  //   sessionStorage.setItem('EndDate', Deger);
  // };

  const TodayHandleChange = () => {
    const today = moment().format('YYYY-MM-DD');
    setEndDate(today);

    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', today);

    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', today);
    handleRefresh();
  };

  const TomorrowHandleChange = () => {
    const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
    setEndDate(tomorrow);

    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', tomorrow);

    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', tomorrow);
    handleRefresh();
  };

  const handleRefreshDate = (e) => {
    setopenChooseDate(false);
    handleRefresh();
  };

  const handleFgsAramaOpen = (event, AtananIsFisNo) => {
    setOpenFgsArama(true);
    setReceiptNo(AtananIsFisNo.toString());
  };
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  };
  const durumMap = new Map([
    [20, t('Başvuru')],
    [21, t('Teknisyende')],
    [22, t('Ustlendi')],
    [33, t('Baslandi')],
    [42, t('Yola_cikildi')]
  ]);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleChange = (event) => {
    setStateDurum(event.target.value);
  };
  const handleChangeWarranty = (event) => {
    setStateWarranty(event.target.value);
  };
  const Kirmizi = {
    color: '#b2102f'
  };
  const Sari = {
    color: '#ffc107'
  };
  const Yesil = {
    color: '#357a38'
  };
  const Mavi = {
    color: '#007FFF'
  };
  const getRandevuColor = (Bas, Bit) => {
    const today = Date.now();
    const bitis = Date.parse(Bit);
    const saat = 1000 * 60 * 60;
    if (bitis > today + saat) {
      return Yesil;
    }
    if (bitis > today + saat / 2) {
      return Sari;
    }

    return Kirmizi;
  };
  const getAvatar = (AtananIs) => {
    const Bas = AtananIs.AppointmentBegin?.substring(12, 2);
    const Bit = AtananIs.AppointmentEnd;
    if ([21, 22, 33, 42, 51, 66, 68, 69].indexOf(parseInt(AtananIs.StatusCode)) === -1) {
      let Kontrol = '';
      const KontrolText = '';
      const KontrolText1 = '';
      if (AtananIs.AppointmentCloseDownControl === 1) {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatar1Atanan}>
            <DoneIcon />
          </Avatar>
        );
      }
      else {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatarAtanan}>
            <ClearIcon />
          </Avatar>
        );
      }
      return (
        <Typography
          component="span"
          variant="h6"
          style={Sari}
        >
          {Kontrol}
          <br />
          {KontrolText}
          <br />
          {KontrolText1}
        </Typography>
      );
    }

    return (
      <Typography
        component="span"
        variant="h6"
        style={getRandevuColor(Bas, Bit)}
      >
        <div>
          {AtananIs.AppointmentBegin?.substring(11, 16)}
          <br />
          {AtananIs.AppointmentEnd?.substring(11, 16)}
        </div>
      </Typography>
    );
  };

  const getIOT = (AtananIs) => {
    if (parseInt(AtananIs.Barcode) === 0) {
      return <div />;
    }
    return (
      <div>
        {loadingIOT ? <CircularProgress style={Mavi} status="loading" /> : <SettingsInputAntennaIcon style={Mavi} onClick={(event) => handleIOTClickOpen(AtananIs)} />}
        <br />
        <br />
      </div>
    );
  };

  const getDurum = (AtananIs) => {
    if (parseInt(AtananIs.ReceiptNo) === 0) {
      return <div />;
    }
    if (AtananIs.StatusCode === 21 || AtananIs.StatusCode === 63 || AtananIs.StatusCode === 7 || AtananIs.StatusCode === 17 || AtananIs.StatusCode === 33) {
      return <ThumbUpIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 22)} />;
    } if (AtananIs.StatusCode === 22 || AtananIs.StatusCode === 51 || AtananIs.StatusCode === 66 || AtananIs.StatusCode === 68) {
      return <EmojiTransportationIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 42)} />;
    } if (AtananIs.StatusCode === 42) {
      return (
        <div>
          <ThumbUpIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 22)} />
          <br />
          <br />
          <PlayCircleFilledWhiteIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />
        </div>
      );
    }
  };

  const handleIOTClick = (AtananIs) => {
    setLoadingIOT(true);
    const Barkod = `${AtananIs.ModelCode + AtananIs.UYIL.toString().substring(2, 4).toString() + AtananIs.SERINO.toString().padStart(6, '0') + AtananIs.UDONEM.toString().padStart(2, '0')}01`;
    const configIOT = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get(`/FileImportExport/ArtemisIOT/${Barkod}`, configIOT)
      .then((response) => {
        if (response.data.type === 'text/plain') {
          setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
          setUyariTip('error');
          setUyari(true);
        } else {
          openBlob(response.data, Barkod);
        }
        setLoadingIOT(false);
      }).catch((error) => {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
        setUyariTip('error');
        setUyari(true);
        setLoadingIOT(false);
      });
  };

  const handleIOTClickOpen = (AtananIs) => {
    // var Uyari = AtananIs.FisNo + " fiş numaralı müşterimizin " + AtananIs.KUL_MODEL_KODU + ' ' + AtananIs.MODEL + ' Ürününe uzaktan bağlanılıp sağlık verilerine ulaşılacaktır. Devam etmek istediğinizdne eminmisiniz?';
    const Uyari = t('IOT_confirm').replace('@FisNo', AtananIs.ReceiptNo).replace('@KulModelKodu', AtananIs.ModelCode).replace('@Model', AtananIs.Model);
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleIOTClick(AtananIs)
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };

  const handleClickOpen = (job, newStatus) => {
    setWorkOrder(job);

    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    GetStatusData(newStatus, job.ReceiptNo);

    function error(err) {
      const Uyari = '';
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);
      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        // setConfirmDescription(`${Uyari} ${newStatusDesc} duruma almak istiyor musunuz?`);
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }

    function success(position) {
      const X1 = job.ENLEM;
      const X2 = job.BOYLAM;
      let Uyari = '';
      let Y1 = '';
      let Y2 = '';
      Y1 = position.coords.latitude;
      Y2 = position.coords.longitude;
      setEnlem(Y1);
      setBoylam(Y2);
      const MesafeSonucAtanan = getDistanceFromLatLonInKm(X1, X2, Y1, Y2).toFixed(1);
      if (isNaN(MesafeSonucAtanan)) {
        MesafeSonuc = 0;
      } else {
        MesafeSonuc = MesafeSonucAtanan;
      }

      if (newStatus === 33 && parseInt(job.ReceiptNo) > 0) {
        if (MesafeSonucAtanan > 100) {
          // Uyari = "Müşteri evinden " + Math.floor(MesafeSonucAtanan) + " metre uzakta işi başlatmaya çalışıyorsunuz!!! İşi başlatmak istediğinize emin misiniz? Müşteri Enlem,Boylam:" + X1 + "," + X2 + " TeknisyenEnlem,Boylam: " + Y1 + ", " + Y2 + " ";
          Uyari = t('mesafe_uyari').replace('@MesafeSonucAtanan', Math.floor(MesafeSonucAtanan)).replace('@X1', X1).replace('@X2', X2)
            .replace('@Y1', Y1)
            .replace('@Y2', Y2);
        }
      }
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);

      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  const handleClickRejectOpen = (jobId) => {
    setConfirmRejectTitle(`${jobId}`);
    setConfirmRejectDescription(t('reject_message').replace('@Recipient', jobId));
    setRejectJob(jobId);
    setRejectOpen(true);
  };

  const handleClickReject = (jobId) => {
    axios.post(`/SetWorkOrderReject/${jobId}`)
      .then((response) => {
        const ResponseData = response.data;
        if (ResponseData.ErrorCode === '0') {
          setUyariTip('success');
          setSortedData(AtananIsler.map((item) => (item.ReceiptNo === jobId
            ? {
              ...item,
              StatusCode: ResponseData.StatusId,
              Durum: ResponseData.StatusDesc,
              DURUM_KODU: ResponseData.StatusId,
            }
            : item)));
          handleRefresh();
        } else {
          setUyariTip('error');
          setresponseMessage({ ErrorCode: ResponseData.ErrorCode, ErrorDescription: ResponseData.ErrorDescription });
        }
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      })
      .catch((error) => {
        let ErrorData = '';
        ErrorData = t('offline_messsage');
        setUyariTip('error');
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      });
  };

  useEffect(() => {
    document.body.style.overflow = 'auto';
  }, [openChooseDate, open]);


  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d * 1000;
  }
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  const SessionUser = getUser();

  const statusUpdate = (job, newStatus) => {
    setOpen(false);
    setLoading2(true);
    
    if(IsAI) 
    {
      AIPrediction();
      setOpenAIDialog(true);
      return;
    }
    
    const newStatusDesc = durumMap.get(newStatus);


    if (newStatus === 33) {
      const baslananIsler = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(33)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (baslananIsler.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('baslandi_error').replace('@FisNo', baslananIsler[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }
    }
    if (newStatus === 42) {
      const yolaCikildiIsler = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(42)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (yolaCikildiIsler.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('yola_cikildi_error').replace('@FisNo', yolaCikildiIsler[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }

      const baslananIslerYolaCikildi = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(33)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (baslananIslerYolaCikildi.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('baslandi_error').replace('@FisNo', baslananIslerYolaCikildi[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }
    }

    const OperationDateParam = moment().utcOffset('+03:00');


    if (isNaN(MesafeSonuc)) {
      MesafeSonuc = 0;
    }

    const data = [{
      AppNr: job.ReceiptNo,
      ServicePaperId: job.ReceiptNo,
      ServiceShopId: SessionUser.ServiceShopId,
      RequestStatus: newStatus,
      ResultNote: '',
      TechnicianId: SessionUser.TechnicianId,
      DeviceStatus: job.StatusCode,
      Latitude: Enlem.toString(),
      Longitude: Boylam.toString(),
      OperationDate: OperationDateParam,
      Distance: Math.floor(MesafeSonuc),
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/SetSiriusWorkOrderStatusUpdate', data, config)
      .then((response) => {
        const ResponseData = response.data[0];
        setresponseMessage(ResponseData);
        if (ResponseData.ErrorCode === '0') {
          setUyariTip('success');
          if (newStatus === 33 && parseInt(job.ReceiptNo) > 0) {
            setTask({
              ...job, StatusCode: newStatus, Durum: newStatusDesc, DURUM_KODU: newStatus,
            });
            history.push(`/WorkOrder/${job.ReceiptNo}/summary`);
          }
          setSortedData(AtananIsler.map((item) => (item.ReceiptNo === job.ReceiptNo
            ? {
              ...item,
              StatusCode: newStatus,
              Durum: newStatusDesc,
              DURUM_KODU: newStatus,
            }
            : item)));
          handleRefresh();
        } else {
          setUyariTip('error');
        }
        setUyari(true);
        setOpen(false);
        setLoading2(false);
      })
      .catch((error) => {
        let ErrorData = '';
        ErrorData = t('offline_messsage');
        setresponseMessage({ ErrorCode: '1000', ErrorDescription: ErrorData });
        setUyariTip('error');
        setUyari(true);
        setOpen(false);
        setLoading2(false);
      });
  };

  const handleClick = (event, AtananIs) => {
    window.open(`${process.env.REACT_APP_MAP_URL + AtananIs.Latitude},${AtananIs.Longitude}`);
    event.persist();
  };

  const handleOpenDate = () => {
    setopenChooseDate(true);
    setConfirmTitle(t('lblTarihSecimi'));
  };

  function handleSearchClick() {
    sessionStorage.setItem('WorkOrderId', sessionWorkOrderId);
    handleRefresh();
    sessionStorage.removeItem('WorkOrderId');
  }

  function handleChangeWorkOrderId(event) {
    sessionStorage.removeItem('WorkOrderId');
    const inputVal = event.target.value;
    // Validate input to allow only numbers and limit to 12 characters
    const validatedInput = inputVal.replace(/\D/g, '').slice(0, 12);
    setSessionWorkOrderId(validatedInput);
  }

  useEffect(() => {
    const uniqueValueSet = new Set();
    const distinctValues = [];
    if (stateDurum === '' && stateWarranty === '') {
      setSortedData(AtananIsler)
      return;
    }
    if (stateDurum !== '' && stateWarranty !== '') {
      AtananIsler.forEach(item => {
        if (!uniqueValueSet.has(item.ReceiptNo) && item.StatusCode == stateDurum && item.WarrantyTypeId == stateWarranty) {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
      })
    }
    else {
      AtananIsler.forEach(item => {
        if (stateDurum !== '' && !uniqueValueSet.has(item.ReceiptNo) && item.StatusCode == stateDurum) {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
        if (stateWarranty !== '' && !uniqueValueSet.has(item.ReceiptNo) && item.WarrantyTypeId == stateWarranty) {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
      })
    }
    setSortedData(distinctValues);

  }, [stateDurum, stateWarranty, AtananIsler]);

  useEffect(() => {
    // Filtreleme işlemi
    const filteredData = filter === ''
      ? [...AtananIsler]
      : AtananIsler.filter((item) =>
        sc(item.CustomerFullName, filter) || sc(item.BASVURU_NOTU, filter) || sc(item.ReceiptNo, filter) ||
        sc(item.BasvuruNedeni, filter) || sc(item.Mahalle, filter) || sc(item.Telefon, filter) || sc(item.Randevu, filter)
        || sc(item.WorkCaseId, filter)
      );
    // Sıralama işlemi
    const sortedData = [...filteredData].sort((a, b) => {
      if (a.StatusCode === 33 || a.StatusCode === 42) {
        if (b.StatusCode !== 33 && b.StatusCode !== 42) {
          return -1;
        }
      } else if (b.StatusCode === 33 || b.StatusCode === 42) {
        return 1;
      }

      const dateA = new Date(moment(a.AppointmentDate).format('YYYY-MM-DD HH:mm'));
      const dateB = new Date(moment(b.AppointmentDate).format('YYYY-MM-DD HH:mm'));

      return dateA - dateB;
    });

    setSortedData(sortedData);
  }, [filter, AtananIsler]);

  const uniqueValuesSet = new Set();
  const distinctAtananIsler = [];

  const uniqueWarrantySet = new Set();
  const distinctWarrantyData = [];
  AtananIsler.forEach(item => {
    if (!uniqueValuesSet.has(item.Status)) {
      uniqueValuesSet.add(item.Status);
      distinctAtananIsler.push(item);
    }
    if (!uniqueWarrantySet.has(item.WarrantyTypeText)) {
      uniqueWarrantySet.add(item.WarrantyTypeText);
      distinctWarrantyData.push(item);
    }
  });

  function GetMaterialOrderSAPCountry() {
    axios
      .post('/GetMaterialOrderSAPCountry/' + SessionUser.TenantId)
      .then(response => {
        if (response.data) {
          if (OrderNr !== '' && OrderNr !== undefined) {
            CreateOrderInSap(OrderNr);
          } else {
            CreateOrderInSap(MaterialOrderId);
          }
        }
      });
  }

  function CreateOrderInSap(MaterialOrderId) {
    axios
      .post('/CreateOrderInSAP/' + MaterialOrderId)
      .then(response => {
        if (response.data[0]?.ErrorCode == 1000) {
          setresponseMessage({
            ErrorCode: response.data[0].ErrorCode,
            ErrorDescription: response.data[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          setOpen1(true);
          setUyari1(responseMessage.ErrorDescription);
          return;
        } else {
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: t('sendSapSuccess')
          });
          setUyariTip('success');
          setUyari(true);
          setOpen1(true);
          setUyari1(responseMessage.ErrorDescription);
        }
      });
  }

  async function AIPrediction() {
    setLoading2(true);
    var row = workOrder;

    const predictionRequest = {
      BASVURU_NEDENI: row.IssueReason,
      BASVURU_NOTU: row.CallCenterNote === null ? '' : row.CallCenterNote,
      FIS_NO: row.ReceiptNo,
      MODEL_KODU: row.MappingModelCode,
      SF_ACIKLAMA: ""
    };

    axiosHeadOffice
      .post('/AIPrediction', predictionRequest)
      .then(result => {
        var response = result.data.Response;
        var responsePredictions = result.data.TAHMINLER;

        if (response.ErrorCode !== '1000') {
          setPredictions(responsePredictions);
          AIDefectsAndMaterials(responsePredictions);
        }
      });
    setLoading2(false);
  }

  async function AIDefectsAndMaterials(predictions) {
    setDefectsAndMaterials([]);
    setLoading2(true);

    const DefectCodes = predictions.map(p => p.HIZMET_KODU);
    const MaterialCodes = predictions.map(p => p.MALZEME_KODU);

    const data = {
      HIZMET_KODU: DefectCodes,
      MALZEME_KODU: MaterialCodes
    };

    axiosHeadOffice
      .post('/GetAIPredictionDefectAndMaterial', data)
      .then(values => {
        if (values.data?.length > 0) {
          var filteredData = values.data;
          setDefectsAndMaterials(filteredData.map((d) => ({
            DefectId: d.DefectId,
            DefectCode: d.DefectCode,
            Defect: d.Defect,
            CategoryLevel2: d.CategoryLevel2,
            DefectType: d.DefectType,
            DefectTypeCode: d.DefectTypeCode,
            MaterialId: d.MaterialId,
            MaterialCode: d.MaterialCode,
            MaterialDsc: d.MaterialDsc
          })));
        } else {
          setDefectsAndMaterials([]);
        }
      });
    setLoading2(false);
  }

  const checkIfTomorrow = (appointmentDate) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const appointment = new Date(appointmentDate);

    return (
      appointment.getDate() === tomorrow.getDate() &&
      appointment.getMonth() === tomorrow.getMonth() &&
      appointment.getFullYear() === tomorrow.getFullYear()
    );
  };

  function TriagePreorderOperations(isOrder) {
    setLoading2(true);
    const data = matchedPairs.length > 0 ? matchedPairs.map(pair => ({
      WorkOrderId: workOrder.ReceiptNo,
      DefectId: pair.defect.DefectId,
      MaterialId: pair.material.MaterialId,
      IsOrder: isOrder,
      EmployeeId: SessionUser.TechnicianId
    })) :
      [{
        WorkOrderId: workOrder.ReceiptNo,
        DefectId: 0,
        MaterialId: 0,
        IsOrder: isOrder,
        EmployeeId: SessionUser.TechnicianId
      }];


    axiosHeadOffice
      .post('/TriagePreorderOperations', data)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setOpen1(true);
          setUyari1(t('lblSuccess') + ' - ' + response.data.ErrorDescription);
          setOpenAIDialog(false);
          // getTasksRequest(parseInt(AtananIsler[0].ReceiptNo));
        }

        else if (response.data.ErrorCode === "10") {
          setOpen1(true);
          setUyari1(isOrder ? t('lblTriageOperationMsg') : t('lblWithoutOrderTip'));
          setOpenAIDialog(false);
          // getTasksRequest(parseInt(AtananIsler[0].ReceiptNo));
        }
        else if (response.data.ErrorCode === "1000") {
          setOpen1(true);
          setUyari1(response.data.ErrorDescription);
        }
      });

    if (isOrder) {
      setOpenTriageMaterialOrder(true);
    }
    handleRefresh();
    setLoading2(false);
  }

  const handleDefectSelect = (defect) => {
    setSelectedDefect(defect);
    setSelectedMaterial(null);
  };

  const handleMaterialSelect = (material) => {
    setSelectedMaterial(material);
  };

  const handleMatch = () => {
    if (selectedDefect && selectedMaterial) {
      setMatchedPairs([...matchedPairs, { defect: selectedDefect, material: selectedMaterial }]);
      setSelectedDefect(null);
      setSelectedMaterial(null);
    }
  };

  const handleDeleteMatchedPair = (index) => {
    const updatedMatchedPairs = [...matchedPairs];
    updatedMatchedPairs.splice(index, 1);
    setMatchedPairs(updatedMatchedPairs);
  };


  function GetDefectsAndMaterialsByWorkOrderId() {
    setLoading2(true);

    axiosHeadOffice
      .get('/GetDefectsAndMaterialsByWorkOrderId/' + workOrder.ReceiptNo)
      .then(response => {
        if (response.data.length > 0) {
          setDefectAndMaterialList(response.data);
        } else {
          setDefectAndMaterialList([]);
        }
      });
    setLoading2(false);
  }

  useEffect(() => {
    if (OpenAIDialog === true)
      GetDefectsAndMaterialsByWorkOrderId();
  }, [OpenAIDialog]);


  function handleAddMatchedPairs(newDefect, newMaterial) {
    if (newDefect !== undefined) {
      setMatchedPairs([...matchedPairs, {
        defect: { Defect: newDefect.DefectDesc, DefectCode: newDefect.UserCode, DefectId: newDefect.Code },
        material: { MaterialCode: newMaterial.MaterialCode, MaterialDsc: newMaterial.MaterialDesc, MaterialId: newMaterial.MaterialId }
      }]);
    }
  }

  const hasMaterialAndDefect = matchedPairs.some(pair => pair.material && pair.defect);

  const getOrderNr = (orderNr) => {
    if (orderNr !== undefined) {
      setOrderNr(orderNr);
    }
  };

  const handleCloseTriageMaterialOrder = () => {
    if (OrderNr === '' || OrderNr === undefined) {
      setOpen1(true);
      setUyari1(t('lblObligationOrderMsg'));
    } else {
      setOpenTriageMaterialOrder(false);
      GetMaterialOrderSAPCountry();
    }
  };


  const handleFilterChange = (e) => {
    dispatch(filterActions.setSearched(e.target.value));
  };

  return (
    <div>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        style={{ paddingTop: 90 }}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      </Snackbar>
      <Paper component="form" className={classes.pageStyleAtanan}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={9} sm={8} container spacing={1}>
            <Grid item xs={12} sm={2}>
              <Select
                native
                value={stateDurum}
                disableUnderline
                className={classes.inputAtanan}
                onChange={handleChange}
                label="Durum"
                fullWidth
              >
                <option aria-label="None" value="">{t('ddl_Tumu')}</option>

                {distinctAtananIsler.length !== 0 ? distinctAtananIsler.map((item) => (

                  <option key={item.StatusCode} value={item.StatusCode}>{item.Status}</option>
                )) : ''}
              </Select>

            </Grid>
            <Grid item xs={12} sm={3}>
              <Select
                native
                value={stateWarranty}
                disableUnderline
                className={classes.inputAtanan}
                onChange={handleChangeWarranty}
                label="Warranty"
                fullWidth
              >
                <option aria-label="None" value="">{t('ddl_Warranty')}</option>
                {distinctWarrantyData.length !== 0 ? distinctWarrantyData.map((item) => (
                  <option key={item.WarrantyTypeId} value={item.WarrantyTypeId}>{item.WarrantyTypeText}</option>
                )) : ''}

              </Select>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Input
                endAdornment={
                  <InputAdornment position="end">
                    <SearchIcon onClick={handleSearchClick} style={{ cursor: 'pointer' }} />
                  </InputAdornment>
                }
                className={classes.searchInputAtanan}
                disableUnderline
                value={sessionWorkOrderId}
                onChange={handleChangeWorkOrderId}
                placeholder={t('WorkOrderSearch')}
                inputProps={{
                  maxLength: 12,
                  pattern: '\\d{0,12}',
                  title: 'Please enter only numeric characters (maximum 12 digits)',
                }}
              />
            </Grid>
            <Grid item xs={4} sm={1}>
              <IconButton
                color="primary"
                onClick={handleRefresh}
                className={classes.iconButtonAtanan}
                aria-label="refresh"
                fullWidth
              >
                <RefreshIcon />
              </IconButton>
            </Grid>
            <Grid item xs={4} sm={1}>
              <IconButton
                color="primary"
                onClick={removeBaslandiJob}
                className={classes.iconButtonAtanan}
                aria-label="reset"
                fullWidth
              >
                <SettingsBackupRestoreIcon />
              </IconButton>
            </Grid>
            <Grid item xs={4} sm={1}>
              <IconButton
                color="primary"
                onClick={handleOpenDate}
                className={classes.iconButtonAtanan}
                aria-label="directions"
              >
                <DateRangeIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4} container spacing={1}>
            <Grid item xs={6} sm={6}>
              <Button
                variant="outlined"
                onClick={TodayHandleChange}
                className={classes.buttonAtanan}
                fullWidth
              >
                {t('lblToday')}
              </Button>
            </Grid>
            <Grid item xs={6} sm={6}>
              <Button
                variant="outlined"
                onClick={TomorrowHandleChange}
                className={classes.buttonAtanan}
                fullWidth
              >
                {t('lblTomorrow')}
              </Button>
            </Grid>
          </Grid>
        </Grid>

      </Paper>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('lblJobSchedule')} style={{ textAlign: 'left' }} />
        <Divider />
        <Paper
          className={classes.searchAtanan}
          elevation={1}
        >
          <SearchIcon
            className={classes.searchIconAtanan}
          />
          <Input
            className={classes.searchInputAtanan}
            disableUnderline
            value={filter}
            onChange={handleFilterChange}
            placeholder={t('search')}
          />
        </Paper>
        {
          loading || loading2 ? <CircularProgress status="loading" />
            : (
              AtananIsler?.length !== 0 ?
                <List>
                  {(SessionUser.TenantId === 16 ? sortedData.sort((a, b) => a.PositionInRoute - b.PositionInRoute) : sortedData.sort((a, b) => a.SIRA - b.SIRA)).map((AtananIs) => (
                    <div key={AtananIs.ReceiptNo}>
                      {AtananIs.PotentialLiabilityActive === 1 ?
                        <Grid container direction="row" justify='flex-end' alignItems='center'>
                          <InfoIcon style={{ color: '#CD0404' }} /><Typography style={{ color: '#CD0404', margin: '10px' }} variant="h6" display="block" gutterBottom>
                            {t('lblPotentialLiabilityClaim')}!</Typography>
                        </Grid>
                        : ''}
                      <ListItem>
                        <ListItemAvatar>
                          <div>
                            {parseInt(AtananIs.PAKET) === 1 && <AccountTreeIcon color="primary" />}
                            {getAvatar(AtananIs)}
                            <br />
                            {getDurum(AtananIs)}
                            <br />
                            {(AtananIs.StatusCode == 21 || AtananIs.StatusCode == 22 || AtananIs.StatusCode == 42 || AtananIs.StatusCode == 33) ?
                              <ThumbUpDownIcon style={Kirmizi} onClick={(event) => handleClickRejectOpen(AtananIs.ReceiptNo)} /> : ''}
                          </div>
                        </ListItemAvatar>
                        <ListItemText>
                          <Grid container direction="row-reverse"
                            justify="flex-start"
                            alignItems="center">
                            <Grid item>
                              {AtananIs.UrgentCustomer === 1 &&
                                (<Tooltip title={t('lblUrgentCustomer')}>
                                  <PriorityHighIcon className={classes.urgentButton} />
                                </Tooltip>)}
                            </Grid>
                          </Grid>
                          <Typography
                            variant="body1"
                            component={RouterLink}
                            to={AtananIs.ReceiptNo > 0 ? `/WorkOrder/${AtananIs.ReceiptNo}/summary` : '#'}
                          >
                            <span className={classes.typeAtanan}>
                              <b>{AtananIs.AppointmentDate?.substring(0, 10)}</b>
                              <br />
                              {t('lblWorkOrder')}  {`:${AtananIs.ReceiptNo}`}
                              <br />
                              {t('lblWorkCase')}  {`:${AtananIs.WorkCaseId}`}
                              <br />
                              {AtananIs.CustomerFullName}
                              <br />
                              {AtananIs.CustomerType}
                              <br />
                              {AtananIs.IssueReason}
                              <br />
                              {AtananIs.Neighborhood}
                              -
                              {AtananIs.Address}
                            </span>
                            <br />
                            {AtananIs.CallCenterNote}
                            <br />
                          </Typography>
                          <div className={classes.fieldsAtanan}>
                            <Grid container spacing={1}>
                              <Grid item xs={2}>
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <PhoneInTalkIcon color="secondary" onClick={(event) => handleFgsAramaOpen(event, AtananIs.ReceiptNo)} />
                                  : AtananIs.StatusCode === 22 && <FastfoodIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />}
                              </Grid>

                              <Grid item xs={8} align="center">
                                <Typography variant="h6">{AtananIs.Status}</Typography>
                              </Grid>
                              <Grid item xs={2} align="right">
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <RoomIcon color="secondary" onClick={(event) => handleClick(event, AtananIs)} />
                                  : AtananIs.StatusCode === 33 && <WorkIcon style={Kirmizi} onClick={(event) => handleClickOpen(AtananIs, 4)} />}
                              </Grid>
                            </Grid>
                          </div>
                        </ListItemText>
                        <ListItemSecondaryAction>
                          {parseInt(AtananIs.ReceiptNo) > 0
                            && (
                              <Tooltip title={t('lblDetaylariGoster')}>
                                <IconButton
                                  color="primary"
                                  component={RouterLink}
                                  to={`/WorkOrder/${AtananIs.ReceiptNo}/summary`}
                                  edge="end"
                                  size="small"
                                >
                                  <ArrowForwardIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider className={classes.dividerAtanan} />
                    </div>
                  ))}
                </List>
                :
                (
                  <div>
                    <Divider />
                    <Card>
                      <CardContent className={classes.content}>
                        <Typography variant="h5" gutterBottom>
                          <br />
                          <br />
                          <LocalCafeIcon />
                          <br />
                          <br />
                          {t('no_job_message')}
                          <br />
                          <br />
                          <br />
                          <br />
                        </Typography>
                      </CardContent>
                    </Card>
                  </div>
                )
            )
        }
        <FgsArama
          onClose={handleFgsAramaClose}
          ReceiptNo={ReceiptNo}
          open={openFgsArama}
        />
      </Card>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ConfirmDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => statusUpdate(confirmJob, confirmnewStatus)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openChooseDate}
        onClose={() => setopenChooseDate(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {/*<Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="TarihSecici"
                  label={t('lblDateSelector')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={EndDate}
                  onChange={(date) => EndDatehandleChange(date)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  minDate={today}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>*/}
          <Typography variant="h6" component="h2" gutterBottom>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                  <KeyboardDatePicker
                    margin="normal"
                    color="primary"
                    inputVariant="outlined"
                    id="BaslangiçTarihi"
                    label={t('BaslangicTarihi')}
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy"
                    variant="outlined"
                    value={StartDate}
                    onChange={(e) => StartDatehandleChange(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                  <KeyboardDatePicker
                    margin="normal"
                    color="primary"
                    inputVariant="outlined"
                    id="BitisTarihi"
                    label={t('BitisTarihi')}
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy"
                    variant="outlined"
                    value={EndDate}
                    onChange={(e) => EndDatehandleChange(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleRefreshDate(e)} color="primary" autoFocus>
            {t('Ok')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={OpenAIDialog}
        onClose={() => setOpenAIDialog(false)}
        fullWidth
        maxWidth="xl"
        style={{ width: '100%', height: '100%' }}
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblAIPredictions')}
        </DialogTitle>
        <DialogContent>
          <React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Typography variant="h6">{t('lblDefects')}</Typography>
                {defectsAndMaterials.map((defect, index) => (
                  defect.DefectCode && defect.Defect && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${defect.CategoryLevel2 + ', ' + defect.DefectType + ' - ' + defect.Defect}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedDefect === defect}
                            onChange={() => handleDefectSelect(defect)}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
              <Grid item xs={2}>
                {/* Match button */}
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleMatch}
                    disabled={!selectedDefect || !selectedMaterial}
                  >
                    {t('lblMatch')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ flexBasis: '40%' }}>
                <Typography variant="h6">{t('lblMaterials')}</Typography>
                {defectsAndMaterials.map((material, index) => (
                  material.MaterialCode && material.MaterialDsc && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${material.MaterialCode}-${material.MaterialDsc}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedMaterial === material && selectedDefect}
                            onChange={() => handleMaterialSelect(material)}
                            disabled={matchedPairs.some(pair => pair.material?.MaterialCode === material.MaterialCode) || !selectedDefect}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Card>
                <DefectTriage matchedPairsArray={matchedPairs ? matchedPairs : []} handleAddMatchedPairs={handleAddMatchedPairs} ReceiptNo={workOrder.ReceiptNo} readonly={false} />
              </Card>
            </Grid>
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblAlreadyUsed')}</Typography>
            {defectAndMaterialList.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair ? `${pair.Defect} | ${pair.Material}` : ''}</Typography>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblMatches')}</Typography>
            {matchedPairs.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair.material ? `${pair.defect.DefectCode}-${pair.defect.Defect} | ${pair.material?.MaterialCode}-${pair.material?.MaterialDsc}` : `${pair.defect.DefectCode}-${pair.defect.Defect}`}</Typography>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'right' }}>
                    <IconButton onClick={() => handleDeleteMatchedPair(index)}>
                      <DeleteIcon style={{ color: '#9B4444' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Grid container spacing={2} justify="center">
              <Grid item>
                <Tooltip title={t('lblWithoutOrderTip')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<RemoveShoppingCartIcon />}
                    endIcon={<span style={{ width: 20 }} />}
                    style={{ backgroundColor: '#8CB9BD' }}
                    onClick={() => TriagePreorderOperations(false)}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblWithoutOrder')}</span>
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={t('lblSaveAndOrder')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    endIcon={<ShoppingCartIcon />}
                    style={{ backgroundColor: '#344955' }}
                    disabled={!hasMaterialAndDefect}
                    onClick={() => {
                      TriagePreorderOperations(true)
                    }}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblSaveAndOrderHeader')}</span>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </React.Fragment>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            endIcon={<CloseIcon />}
            style={{ backgroundColor: '#344955' }}
            onClick={() => setOpenAIDialog(false)}
          >
            <span style={{ margin: '0 auto' }}>{t('lblCancel')}</span>
          </Button>
        </DialogActions>
        <Backdrop open={loading2} style={{ zIndex: 1000 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      <Dialog
        open={OpenTriageMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => handleCloseTriageMaterialOrder()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <TriageMaterialOrder
            MaterialIds={matchedPairs.map(p => p.material?.MaterialId)}
            WorkOrderId={workOrder.ReceiptNo}
            ServiceShopId={workOrder.ServiceShopId}
            getOrderNr={getOrderNr}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseTriageMaterialOrder()} color="primary">
            <CloseIcon />
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={rejectOpen}
        onClose={() => setRejectOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmRejectTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmRejectDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => handleClickReject(rejectJob)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setRejectOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={() => setOpen1(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('lblInfo')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen1(false)} color="primary">
            {t('lblOk')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

Notifications.propTypes = {
  className: PropTypes.string
};

// export default Notifications;


export default connect(
  (state) => ({
    loading: state.tasks1.loading,
    tasks: state.tasks1,
    materialReducer: state.materialReducer,
    defectReducer: state.defectReducer,
    labourReducer: state.labourReducer
  }),
  {
    setTask, getTasksRequest,
    resetDefects, resetLabours, resetMaterials, addDefects, addLabours, addMaterials, getDefectRequest, getLabourRequest, getMaterialRequest
  }
)(Notifications);
